import * as THREE from 'three'
import React from "react";
import { Html } from "@react-three/drei";

//import 'stylesheets/GameOverText.css'
import { useAppStore } from 'startup/appStore'
import { useShallow } from 'zustand/react/shallow'

export default function GameOverText({
    position,
}) {
    const { 
        gameStatus,
        setGameStatus,
        setPositions,
        //rabbitStartPosition,
        //foxStartPosition,
    } = useAppStore( useShallow((state) => ({
        gameStatus: state.gameStatus,
        setGameStatus: state.setGameStatus,
        setPositions: state.setPositions,
        //rabbitStartPosition: state.positions['rabbit'].start,
        //foxStartPosition: state.positions['fox'].start,
    })));

    // why are the start positions modified?
    // workaround: use these values instead
    const foxStartPosition = new THREE.Vector3(2, 1.5, 0);
    const rabbitStartPosition = new THREE.Vector3(-2, 0, 0);

    // css styles
    const white = '#f9f9f9';
    const black = '#36383F';
    const gray = '#85888C';
    const green = '#3FB950';
    const red = '#a31d14';

    if (gameStatus !== 'end') return null;

    return (
        <Html
            position={position}
        >
            <h1
                className='GameOver'
                style={{
                    width: '200px',
                    color: red,
                    textShadow: `${black} 2px 2px`,
                }}
            >
                Game Over
            </h1>
            <button
                onClick={() => {
                    setPositions('fox', foxStartPosition);
                    setPositions('rabbit', rabbitStartPosition);
                    setGameStatus('beforeStart');
                }}
                //className='PlayAgain'
                style={{
                    color: white,
                    backgroundColor: green,
                    border: 'none',
                    borderRadius: '15%',
                    boxShadow: `1px 3px 3px ${gray}`,
                    cursor: 'pointer',
                    padding: '10px 20px',
                    margin: '40px',
                }}
            >
                Play Again
            </button>
        </Html>
    );
};

